import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { NutritionActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-nutrition-slot-v2',
    templateUrl: './nutrition-slot-v2.component.html',
    styleUrl: './nutrition-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NutritionSlotComponentV2 implements SheetSlotComponentBase {

	action!: NutritionActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: NutritionActionV2 | null) {
		this.action = action as NutritionActionV2;
		this.value = this.action.amountEaten?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}